var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2183 12.2183C14.2284 10.2082 14.2284 6.94913 12.2183 4.93903C10.2082 2.92893 6.94913 2.92893 4.93903 4.93903C2.92893 6.94913 2.92893 10.2082 4.93903 12.2183C6.94913 14.2284 10.2082 14.2284 12.2183 12.2183ZM13.3101 15.7365C9.97925 17.9433 5.44731 17.5793 2.51263 14.6447C-0.837542 11.2945 -0.837542 5.8628 2.51263 2.51263C5.8628 -0.837542 11.2945 -0.837542 14.6447 2.51263C17.5793 5.44731 17.9433 9.97925 15.7365 13.3101L19.4975 17.0711C20.1675 17.7411 20.1675 18.8274 19.4975 19.4975C18.8274 20.1675 17.7411 20.1675 17.0711 19.4975L13.3101 15.7365Z",
    fill: "#2FC18C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchButton);
export default __webpack_public_path__ + "static/media/searchButton.fc9802714ddb63728b109135dfa76860.svg";
export { ForwardRef as ReactComponent };